import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { AgentService } from '../agent.service';
import { AuthService } from 'src/app/auth/auth.service';
import { externalParameters, externalBranches, externalMembershipType, externalSponsporedType } from '../capture/state-file';
import { Agent } from 'src/app/shared/agent.model';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { SuccessComponent } from 'src/app/success/success.component';
const _zones = externalParameters.zones;
const _branches = externalBranches.branches;
const _membershipType = externalMembershipType;
const _sponsoredType = externalSponsporedType;

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.css']
})
export class UpdateUserComponent implements OnInit {
  agentForm: FormGroup;
  zones: string[] = _zones;
  branches: string[] = _branches;
  membershipTypes: string[] = _membershipType;
  sponsoredTypes: string[] = _sponsoredType;
  uniqueID: string;
  states: any;
  selectedStates: any;
  loading: boolean = false;
  lga: any[];
  depots: any[];
  uniqueId: string;
  userInformation: Agent;
  title: string = "Take Picture";
  branchType: string = "";
  sponsoredType: string = "";
  membership: string = "";
  ptd_endorsed_type: string = "";
  image: string | File  = "";
  isFetched: boolean = false;

  constructor(
    private SpinnerService: NgxSpinnerService,
    private agentService: AgentService,
    private authService: AuthService,
    public formBuilder: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.init();
    this.authService.getAgentDataStatus()
      .subscribe(responseData => {
        this.userInformation = responseData;
      });
  }

  private init() {
    this.agentForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      middlename: ['', Validators.required],
      surname: ['', Validators.required],
      gender: ['', Validators.required],
      address: ['', Validators.required],
      dob: ['', Validators.required],
      phone_no: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^[0-9]+[0-9]*$/)])],
      verifiedId: ['', Validators.required],
      vehicleNumber: ['', Validators.required],
      verifiedIdType: ['', Validators.required],
      transportation_type: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      zone: ['', Validators.required],
      branch: ['', Validators.required],
      uniqueId: ['',],
      unit: ['', Validators.required],
      depot: ['', Validators.required],
      state: ['', Validators.required],
      membership_type: ['', this.conditionalRequiredValidatorForMembershipType],
      drivers_licence: ['', this.conditionalRequiredValidatorForMembershipTypeDOW],
      vehicle_license: ['', this.conditionalRequiredValidatorForMembershipTypeDOW],
      vehicle_license_expiry: ['', this.conditionalRequiredValidatorForMembershipTypeDOW],
      contact_number: ['', Validators.compose([this.conditionalRequiredValidatorForMembershipTypeDOW, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^[0-9]+[0-9]*$/)])],
      truck_owner_full_name: ['', this.conditionalRequiredValidatorForMembershipTypeDOW],
      truck_owner_phone_no: ['', Validators.compose([this.conditionalRequiredValidatorForMembershipTypeDOW, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^[0-9]+[0-9]*$/)])],
      sponsored_by: ['', this.conditionalRequiredValidatorForMembershipTypeDOW],
      sponsored_by_name: ['', this.conditionalRequiredValidatorForMembershipTypeDOW],
      capture_location: ['', this.conditionalRequiredValidatorForMembershipTypeDOW],
    });
  }

  conditionalRequiredValidatorForMembershipType: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.branchType === 'PTD' && Validators.required(control)) {
      return { 'required': true };
    }
    return null;
  };

  conditionalRequiredValidatorForMembershipTypeDOW: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.membership === this.membershipTypes[1] && Validators.required(control)) {
      return { 'required': true };
    }
    return null;
  };

  selectZone(value: any) {
    if (value == "Kaduna") {
      this.states = externalParameters.kaduna_states;
      this.depots = externalParameters.kaduna_states[externalParameters.kaduna_states.length - 1].depots;
    } else if (value == "Lagos") {
      this.states = externalParameters.lagos_states;
      this.depots = externalParameters.lagos_states[externalParameters.lagos_states.length - 1].depots;
    } else if (value == "Warri") {
      this.states = externalParameters.warri_states;
      this.depots = externalParameters.warri_states[externalParameters.warri_states.length - 1].depots;
    } else {
      this.states = externalParameters.port_harcourt_zones;
      this.depots = externalParameters.port_harcourt_zones[externalParameters.port_harcourt_zones.length - 1].depots;
    }
  }


  selectState(value) {
    const myStates = this.states.find(state => state.state === value);
    if (this.agentForm.value.zone == 'PTD') {
      this.lga = myStates.units;
    }
    else {
      this.lga = myStates.lga;
    }

  }

  selectBranch(value) {
    this.branchType = value;
    this.agentForm.get('membership_type').setValidators(this.conditionalRequiredValidatorForMembershipType);
    this.agentForm.get('membership_type').updateValueAndValidity();
    
  }

  selectPTDType(value) {
    this.membership = value;
    const fieldsToUpdate = [
      'drivers_licence',
      'vehicle_license',
      'vehicle_license_expiry',
      'contact_number',
      'truck_owner_full_name',
      'truck_owner_phone_no',
      'sponsored_by',
      'capture_location',
      'sponsored_by_name'
    ];

    fieldsToUpdate.forEach(field => {
      const control = this.agentForm.get(field);
      control.setValidators(this.conditionalRequiredValidatorForMembershipTypeDOW);
      control.updateValueAndValidity();
    });
  }

  selectPTDSponsoredType(value) {
    this.sponsoredType = value;
  }

  onSubmit() {
    this.SpinnerService.show();
    // TODO: save
    this.agentService.updateExistingUsers(this.uniqueID, this.agentForm.value)
      .pipe(finalize(() => {
        this.uniqueId = null;
        this.SpinnerService.hide();
      }))
      .subscribe(responseData => {
        this.agentForm.reset();
        this.image = "";
        this.dialog.open(SuccessComponent, { data: { message: responseData.message } });
      });
  }
  // TODO: fetch
  fetchUser() {
    this.SpinnerService.show();
    this.agentService.getUserByUniqueId(this.uniqueID)
      .pipe(finalize(() => {
        this.SpinnerService.hide();
      }))
      .subscribe(response => {
        this.isFetched = true;
        this.image = response.user.image ?? "";
        this.agentForm.setValue({
          firstname: response.user.firstname ?? '',
          middlename: response.user.middlename ?? '',
          surname: response.user.surname ?? '',
          gender: response.user.gender ?? '',
          address: response.user.address ?? '',
          dob: response.user.dob ?? '',
          phone_no: response.user.phone_no ?? '',
          verifiedId: response.user.verifiedId ?? '',
          vehicleNumber: response.user.vehicleNumber ?? '',
          verifiedIdType: response.user.verifiedIdType ?? '',
          transportation_type: response.user.transportation_type ?? '',
          email: response.user.email ?? '',
          uniqueId: response.user.uniqueId ?? '',
          zone: response.user.zone ?? '',
          branch: response.user.branch ?? '',
          membership_type: response.user.membership_type ?? '',
          drivers_licence: response.user.drivers_licence ?? '',
          vehicle_license: response.user.vehicle_license ?? '',
          vehicle_license_expiry: response.user.vehicle_license_expiry ?? '',
          contact_number: response.user.contact_number ?? '',
          truck_owner_full_name: response.user.truck_owner_full_name ?? '',
          truck_owner_phone_no: response.user.truck_owner_phone_no ?? '',
          sponsored_by: response.user.sponsored_by ?? '',
          sponsored_by_name: response.user.sponsored_by_name ?? '',
          capture_location: response.user.capture_location ?? '',
          unit: response.user.unit ?? '',
          depot: response.user.depot ? response.user.depot : '',
          state: response.user.state ?? '',
        });
        this.branchType = response.user.branch ?? '';
        this.sponsoredType = response.user.sponsored_by ?? '';
        this.membership = response.user.membership_type ?? '';
        if (this.agentForm.value.zone) {
          this.selectZone(this.agentForm.value.zone);
          if (this.agentForm.value.state) {
            this.selectState(this.agentForm.value.state);
          }
        }
      })
  }

  logout() {
    this.authService.logout();
  }

}
